export {
  clampPosterUnit,
  getPosterImageFrame as getPosterImageFrameStyle,
} from '@radious/catalog/poster-focal';
